import { TypeIdSchema } from '@unipile/db';
import { Type, type Static } from '@sinclair/typebox';
import { InsertApplicationSettingSchema } from './application-setting.schema';
import { InsertApplicationSchema } from './application.schema';

export const CreateApplicationBodySchema = Type.Object(
  {
    name: Type.String({ minLength: 1, maxLength: 255 }),
    production: Type.Optional(InsertApplicationSchema.properties.production),
  },
  { additionalProperties: false },
);

export const UpdateApplicationBodySchema = Type.Partial(Type.Pick(InsertApplicationSchema, ['name']), {
  additionalProperties: false,
});

export const UpdateApplicationSettingsBodySchema = Type.Array(
  Type.Omit(InsertApplicationSettingSchema, ['app_id'], {
    additionalProperties: false,
  }),
);

export const UpdateApplicationSettingsParamsSchema = Type.Object({
  id: TypeIdSchema('app', { description: 'The identifier of the application to update' }),
});

export type CreateApplicationBody = Static<typeof CreateApplicationBodySchema>;
export type UpdateApplicationBody = Static<typeof UpdateApplicationBodySchema>;
export type UpdateApplicationSettingsBody = Static<typeof UpdateApplicationSettingsBodySchema>;
